import * as api from '../../../../api';

import { Col, Container, Row } from 'react-bootstrap';

import ResultsList from './ResultsList';
import PaginationControls from './PaginationControls';

import { Loader, Typography } from '@vivaahealth/design-system';

interface Props {
  pageOffset: number;
  pageLimit: number;
  isLoading: boolean;
  currentPage: number;
  onPageChange: (pageNumber: number) => void;
  setCurrentPage: (value: number) => void;
  providers?: api.PrevisitProvider.SafeProviderWithPractices[];
  totalPages?: number;
}

const Results: React.FC<Props> = ({
  pageOffset,
  pageLimit,
  isLoading,
  currentPage,
  onPageChange,
  setCurrentPage,
  providers,
  totalPages,
}) => {
  const handlePageClick = (pageNumber: number) => {
    setCurrentPage(pageNumber);
    onPageChange(pageNumber);
  };

  if (isLoading || !providers) {
    return (
      <Col className="d-flex flex-column px-0">
        <Loader className="m-auto" label="Loading providers..." />
      </Col>
    );
  }

  return (
    <Col className="d-flex flex-column px-0">
      {providers.length ? (
        <ResultsList
          currentProviders={providers}
          pageOffset={pageOffset}
          pageLimit={pageLimit}
        />
      ) : (
        <Container>
          <Row className="py-4 px-3 px-sm-0">
            <Typography variant="title-large" bold className="ps-0 pb-2">
              Suggestions for improving your results:
            </Typography>
            <ul className="ps-4">
              <li>
                <Typography variant="paragraph-large">
                  Try selecting another specialty from the search menu dropdown
                </Typography>
              </li>
            </ul>
          </Row>
        </Container>
      )}
      <PaginationControls
        currentPage={currentPage}
        onPageClick={handlePageClick}
        totalPages={totalPages}
      />
    </Col>
  );
};

export default Results;
